import { Component } from '@verndale/core';

class BoatDetailsModal extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      rightContainer: document.querySelector('.main-block__container-right'),
      formsBlockContainer: document.querySelector('.forms-block__container'),
    };
  }

  addListeners() {
    this.dom.el.addEventListener('click', this.handleOpen.bind(this));
    // this.dom.showAllBtn.addEventListener('click', this.handleShowAll.bind(this));
    // this.dom.showMoreBtn.addEventListener('click', this.handleShowAll.bind(this));
    // document.addEventListener('keydown', this.handleEscClose.bind(this));
  }

  handleOpen() {
    this.dom.rightContainer.style.display = 'block';
    this.dom.formsBlockContainer.classList.add('pop-up');
    document.body.style.overflow = 'hidden';
  }
}

export default BoatDetailsModal;
